import React from "react";
import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import BitSightCredentialsForm from "./BitSightCredentialsForm";
import BitSightConfigListing from "./BitSightConfigListing";

export default function BitSightPullAndPushView(props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={BitSightCredentialsForm}
      PullConfigListingView={BitSightConfigListing}
    />
  );
}
